module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/tile_babyshower-afd34953f77f4422c18706d0b2a630a2.jpg";